var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',{class:['transition-all', 'duration-300'],attrs:{"tag":"main","app":""}},[_c('container',{class:['2xl:max-w-screen-2xl', 'xl:max-w-screen-xl', 'mx-auto', 'mt-6', 'py-10', 'px-8']},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ba7414a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-main.vue
// module id = null
// module chunks = 